<div class="webhooks-settings">
  <h1>{{ 'SETTINGS.WEBHOOKS.TITLE' | translate }}</h1>

  @if (webhookEnabled()) {
    <div class="actions">
      <orbit-button
        [label]="'SETTINGS.WEBHOOKS.DISABLE' | translate"
        [icon]="faPowerOff"
        [type]="'secondary'"
        (click)="toggleWebhookStatus()" />
    </div>
  }

  <!-- Loading indicator -->
  @if (loading()) {
    <div class="loading-container">
      <div class="loading-spinner"></div>
    </div>
  } @else {
    <div class="webhook-section">
      <h2>{{ 'SETTINGS.WEBHOOKS.CONFIGURATION' | translate }}</h2>

      <div class="webhook-card">
        <div class="card-section">
          <h3>{{ 'SETTINGS.WEBHOOKS.ENDPOINT_URL' | translate }}</h3>
          @if (updatingEndpoint()) {
            <div class="loading-container">
              <div class="loading-spinner"></div>
            </div>
          } @else {
            <div class="endpoint-display">
              @let endpointUrlValue = endpointUrl();
              @if (endpointUrlValue) {
                <p class="endpoint-url">{{ endpointUrlValue }}</p>
              } @else {
                <p class="not-configured">
                  {{ 'SETTINGS.WEBHOOKS.NOT_CONFIGURED' | translate }}
                </p>
              }
              <orbit-button
                [label]="
                (endpointUrlValue
                  ? 'SETTINGS.WEBHOOKS.UPDATE_ENDPOINT'
                  : 'SETTINGS.WEBHOOKS.CONFIGURE_ENDPOINT'
                ) | translate"
                [icon]="faGear"
                (click)="openWebhookDialog()" />
            </div>
          }
        </div>

        @if (webhookEnabled()) {
          <div class="card-section">
            <h3>{{ 'SETTINGS.WEBHOOKS.SECRET_KEY' | translate }}</h3>
            <p class="description">{{ 'SETTINGS.WEBHOOKS.SECRET_NOT_VISIBLE' | translate }}</p>
            @if (rotatingSecret()) {
              <div class="loading-container">
                <div class="loading-spinner"></div>
              </div>
            } @else {
              @if (secret()) {
                <div class="secret-display">
                  <div class="secret-value">
                    @let secretVisibleValue = secretVisible();
                    <input [type]="secretVisibleValue ? 'text' : 'password'" [value]="secret()" readonly />
                    <orbit-button
                      [icon]="secretVisibleValue ? faEyeSlash : faEye"
                      [type]="'icon'"
                      (click)="toggleSecretVisibility()" />
                  </div>
                  <orbit-button
                    [label]="'SETTINGS.WEBHOOKS.ROTATE_SECRET' | translate"
                    [icon]="faRotate"
                    (click)="rotateSecret()" />
                  </div>
                }
              }
            </div>
          <div class="card-section">
            <h3>{{ 'SETTINGS.WEBHOOKS.TEST_WEBHOOK' | translate }}</h3>
            @if (testingWebhook()) {
              <div class="loading-container">
                <div class="loading-spinner"></div>
              </div>
            } @else {
              <p class="description">{{ 'SETTINGS.WEBHOOKS.TEST_DESCRIPTION' | translate }}</p>
              <div class="test-actions">
                <orbit-button
                  [label]="'SETTINGS.WEBHOOKS.SEND_TEST' | translate"
                  [icon]="faPaperPlane"
                  (click)="testWebhook()" />

                @if (testingSent()) {
                  <span class="test-sent">
                  {{ 'SETTINGS.WEBHOOKS.TEST_SENT' | translate }}
                </span>
                }
              </div>
            }
          </div>

          <!-- Webhook Features Section -->
          <div class="card-section">
            <h3>{{ 'SETTINGS.WEBHOOKS.FEATURES' | translate }}</h3>
            <p class="description">{{ 'SETTINGS.WEBHOOKS.FEATURES_DESCRIPTION' | translate }}</p>

            @if (loadingWebhookFeatures()) {
              <div class="loading-container">
                <div class="loading-spinner"></div>
              </div>
            } @else {
              <div class="webhook-features">
                @for (webhookType of availableWebhookTypes(); track webhookType) {
                  <div class="webhook-feature-item">
                    <div class="webhook-feature-info">
                      <code>{{ webhookType }}</code>
                      <p>{{ getWebhookDescription(webhookType) }}</p>
                    </div>

                    <div class="webhook-feature-toggle">
                      @if (updatingWebhookFeature()) {
                        <div class="mini-spinner"></div>
                      } @else {
                        <label class="switch">
                          <input
                            type="checkbox"
                            [checked]="isWebhookFeatureEnabled(webhookType)"
                            [disabled]="!webhookEnabled()"
                            (change)="toggleWebhookFeature(webhookType, !isWebhookFeatureEnabled(webhookType))"
                          />
                          <span class="slider round"></span>
                        </label>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

  <!-- Available Events - Now dynamically generated from the API data -->
  @if (!loading() && !webhookEnabled() && availableWebhookTypes().length === 0) {
    <div class="webhook-section">
      <h2>{{ 'SETTINGS.WEBHOOKS.AVAILABLE_EVENTS' | translate }}</h2>
      <p class="intro">{{ 'SETTINGS.WEBHOOKS.INTRO' | translate }}</p>

      <div class="webhook-card events-card">
        @if (loadingWebhookFeatures()) {
          <div class="loading-container">
            <div class="loading-spinner"></div>
          </div>
        } @else {
          <div class="event-category">
            <h3>{{ 'SETTINGS.WEBHOOKS.AVAILABLE_WEBHOOK_TYPES' | translate }}</h3>
            @for (webhookType of availableWebhookTypes(); track webhookType) {
              <div class="event-item">
                <code>{{ webhookType }}</code>
                <p>{{ getWebhookDescription(webhookType) }}</p>
              </div>
            }
          </div>

          <div class="event-category">
            <h3>{{ 'SETTINGS.WEBHOOKS.TEST_EVENTS' | translate }}</h3>
            <div class="event-item">
              <code>test.webhook</code>
              <p>{{ 'SETTINGS.WEBHOOKS.TEST_WEBHOOK_DESC' | translate }}</p>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
